import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDeskOffice2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDeskOffice2"><Path d="M5.5 3.5H14.5V9.5H5.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M10 9.75V11.25" stroke="currentColor" strokeLinecap="square"/><Path d="M19.75 16H13.25" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 20.5V11.5H12.75M12.75 11.5H20.5V20.5H12.75V11.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDeskOffice2;
